import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalTypes } from 'features/order-tracker/shared-components/Modal/constants';
import { EditIcon } from 'features/order-tracker/shared-components/svg';
import { confirmAmendsToAppointment, openModal, setIsReadyToConfirm } from 'features/order-tracker/store/actions';
import { useTrackModalLoadAnalytics } from 'features/order-tracker/store/hooks';
import { getAmendAppointmentInfo, getIsAmendSiteContactEnabled } from 'features/order-tracker/store/selectors';
import { getAlternativeDateAndSlotFormat, getDateAndTimeForAmendAppointment } from 'features/order-tracker/utils';

import {
  ANALYTICS_APPT_MODAL,
  ANALYTICS_APPT_MODAL_CANCEL,
  ANALYTICS_APPT_MODAL_CONFIRM,
  ANALYTICS_APPT_MODAL_EDIT,
  CANCEL_LABEL,
  CONFIRM_LABEL,
  DATE_LABEL,
  EDIT_DETAILS_LABEL,
  EMAIL_LABEL,
  NAME_LABEL,
  PHONE_LABEL,
  SLOT_LABEL,
} from './constants';

import styles from './styles.module.scss';

export const AmendsConfirmation: React.FC = () => {
  const confirmRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const {
    selectedSlot,
    slotsType,
    contacts,
    selectedContact,
    appointmentInfo: { formattedDate },
  } = useSelector(getAmendAppointmentInfo);
  const originDateAndSlotInfo = getAlternativeDateAndSlotFormat(formattedDate);
  const isAmendSiteContactEnabled = useSelector(getIsAmendSiteContactEnabled);
  const { date, dateWithYear, time } = getDateAndTimeForAmendAppointment(
    selectedSlot || originDateAndSlotInfo,
    slotsType,
  );
  const { phone, email, fullName } = contacts.find((item) => item.contactKey === selectedContact) || {};

  const infoToConfirm = [
    { title: DATE_LABEL, value: date },
    { title: SLOT_LABEL, value: time },
    { title: NAME_LABEL, value: fullName },
    { title: PHONE_LABEL, value: phone },
    { title: EMAIL_LABEL, value: email },
  ];

  const infoToShow = isAmendSiteContactEnabled ? infoToConfirm : infoToConfirm.slice(0, 2);

  useTrackModalLoadAnalytics(confirmRef, ANALYTICS_APPT_MODAL);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const returnToPreviousPage = (): void => {
    dispatch(setIsReadyToConfirm(false));
  };

  // function onCloseAppointmentLoad() {
  //   // load the form and store status (true/false) in neb_status
  //   const nebStatus = window.KAMPYLE_ONSITE_SDK.loadForm(MEDALLIA_AMMEND_FORM_ID);
  //   if (nebStatus === true) {
  //     window.KAMPYLE_ONSITE_SDK.showForm(MEDALLIA_AMMEND_FORM_ID);
  //   }
  // }

  const confirmHandler = (): void => {
    // onCloseAppointmentLoad();
    infoToConfirm[0].value = dateWithYear;
    dispatch(
      confirmAmendsToAppointment({
        infoToConfirm,
        confirmRef,
      }),
    );
  };
  const cancelModal = (): void => {
    dispatch(openModal({ modalType: ModalTypes.AmendAppointment }));
  };

  return (
    <div ref={confirmRef} className={styles.amendsConfirmationContentWrapper}>
      <div className={styles.amendsInformationBlock}>
        {infoToShow.map(({ title, value }) => (
          <div key={title} className={styles.infoLine}>
            <h5>{title}</h5>
            <p>{value}</p>
          </div>
        ))}
        <button
          className={styles.editButton}
          onClick={returnToPreviousPage}
          type="button"
          data-analytics-link={ANALYTICS_APPT_MODAL_EDIT}
        >
          <EditIcon className={styles.editIcon} />
          {EDIT_DETAILS_LABEL}
        </button>
      </div>
      <div className={styles.actionButtonsContainer}>
        <button onClick={cancelModal} type="button" data-analytics-link={ANALYTICS_APPT_MODAL_CANCEL}>
          {CANCEL_LABEL}
        </button>
        <button onClick={confirmHandler} type="submit" data-analytics-link={ANALYTICS_APPT_MODAL_CONFIRM}>
          {CONFIRM_LABEL}
        </button>
      </div>
    </div>
  );
};
